import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0118] to-[#1a0a2e] text-white p-6 sm:p-12">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white mb-6">
          <ArrowLeft size={20} />
          Back to Nexi
        </Link>
        
        <h1 className="text-3xl sm:text-4xl font-bold mb-2 bg-gradient-to-r from-purple-500 to-cyan-500 bg-clip-text text-transparent">
          Terms of Service
        </h1>
        <p className="text-white/50 mb-8">Last updated: January 2025</p>

        <div className="space-y-8 text-white/80">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Nexi AI ("the App"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the App.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Description of Service</h2>
            <p>
              Nexi AI is an artificial intelligence-powered assistant that provides:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Conversational AI responses to user queries</li>
              <li>Document creation and export capabilities</li>
              <li>Image analysis features</li>
              <li>Voice input functionality</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. User Responsibilities</h2>
            <p>You agree to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Use the App only for lawful purposes</li>
              <li>Not use the App to generate harmful, illegal, or misleading content</li>
              <li>Not attempt to reverse engineer, copy, or redistribute the App</li>
              <li>Not use the App to infringe on any third-party rights</li>
              <li>Be responsible for all content you input into the App</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Intellectual Property</h2>
            <p>
              The App, including its design, code, graphics, logo, and "Nexi AI" name, is the exclusive property of Nexi AI and is protected by copyright and other intellectual property laws. 
            </p>
            <p className="mt-2">
              <strong>© 2025 Nexi AI. All Rights Reserved.</strong>
            </p>
            <p className="mt-2">
              You may not copy, modify, distribute, sell, or lease any part of our App or included software, nor may you reverse engineer or attempt to extract the source code.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. AI-Generated Content</h2>
            <p>
              Nexi AI uses artificial intelligence to generate responses. You understand that:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>AI responses may not always be accurate or complete</li>
              <li>AI-generated content should be verified before professional use</li>
              <li>The App is not a substitute for professional advice (legal, medical, financial, etc.)</li>
              <li>You are responsible for how you use AI-generated content</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. User Content</h2>
            <p>
              You retain ownership of content you input into the App. However, by using the App, you grant us a license to process your content to provide our services. We do not claim ownership of your conversations or uploaded images.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Nexi AI shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or use, arising out of your use of the App.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">8. Disclaimer of Warranties</h2>
            <p>
              The App is provided "as is" without warranties of any kind. We do not guarantee that the App will be error-free, uninterrupted, or that AI responses will be accurate or suitable for your specific needs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">9. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your access to the App at any time, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">10. Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of the App after changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">11. Contact</h2>
            <p>
              For questions about these Terms, contact us at:
            </p>
            <p className="mt-2">
              <strong>Email:</strong> support@nexi-ai.app
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-white/50">
          <p>© 2025 Nexi AI. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
